/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_PaletteInputs */

const en_image_inspector_palette = /** @type {(inputs: Image_Inspector_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palette`)
};

const ar_image_inspector_palette = /** @type {(inputs: Image_Inspector_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة الألوان`)
};

const bn_image_inspector_palette = /** @type {(inputs: Image_Inspector_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্যালেট`)
};

const de_image_inspector_palette = /** @type {(inputs: Image_Inspector_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palette`)
};

const es_image_inspector_palette = /** @type {(inputs: Image_Inspector_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paleta`)
};

const fr_image_inspector_palette = /** @type {(inputs: Image_Inspector_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palette`)
};

const pt_image_inspector_palette = /** @type {(inputs: Image_Inspector_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paleta`)
};

const zh_image_inspector_palette = /** @type {(inputs: Image_Inspector_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调色板`)
};

const tr_image_inspector_palette = /** @type {(inputs: Image_Inspector_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palet`)
};

const ru_image_inspector_palette = /** @type {(inputs: Image_Inspector_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Палитра`)
};

const pl_image_inspector_palette = /** @type {(inputs: Image_Inspector_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paleta`)
};

/**
* | output |
* | --- |
* | "Palette" |
*
* @param {Image_Inspector_PaletteInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_palette = /** @type {((inputs?: Image_Inspector_PaletteInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_PaletteInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_palette(inputs)
	if (locale === "bn") return bn_image_inspector_palette(inputs)
	if (locale === "de") return de_image_inspector_palette(inputs)
	if (locale === "es") return es_image_inspector_palette(inputs)
	if (locale === "fr") return fr_image_inspector_palette(inputs)
	if (locale === "pt") return pt_image_inspector_palette(inputs)
	if (locale === "zh") return zh_image_inspector_palette(inputs)
	if (locale === "tr") return tr_image_inspector_palette(inputs)
	if (locale === "ru") return ru_image_inspector_palette(inputs)
	if (locale === "pl") return pl_image_inspector_palette(inputs)
	return en_image_inspector_palette(inputs)
});